/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest
 */
export interface JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest
     */
    userAgent?: string;
}

export function JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequestFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest {
    return JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequestFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userAgent': !exists(json, 'userAgent') ? undefined : json['userAgent'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequestToJSON(value?: JpCoBenefitoneBsdpBffPresentationRequestConfirmPayPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userAgent': value.userAgent,
    };
}

